﻿'use strict'

var
    popup = require('./popup'),
    validation = require('./validation.js');

function showErrorUpdateOnlyText(error, errorTitle) {
    popup.openCenter('errorSummaryWindow');
    $(".js-errorJob").html(error);

    if (errorTitle)
        $("#js-errorTitle").html(errorTitle);

    $("#errorWindowClose").on('click', function () {
        popup.close('errorSummaryWindow');
    });
}

function showErrorUpdate(elementId, error) {
    popup.openCenter('errorSummaryWindow');
    $(".js-errorJob").html(error);

    $("#errorWindowClose").on('click', function () {
        validation.checkElement($("#" + elementId));
        validation.hideAlerts();
        popup.close('errorSummaryWindow');
    });
}

module.exports = {
    showErrorUpdate: showErrorUpdate,
    showErrorUpdateOnlyText: showErrorUpdateOnlyText
};